import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getRemoteConfig } from "firebase/remote-config";
import { getFirestore } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDYGZusOGUqr4k1olrg2lhGNtrN0SQp6C8",
  authDomain: "grupo-diana-ad96a.firebaseapp.com",
  projectId: "grupo-diana-ad96a",
  storageBucket: "grupo-diana-ad96a.firebasestorage.app",
  messagingSenderId: "286614156372",
  appId: "1:286614156372:web:e117d85e4269597027e9c1",
  measurementId: "G-2PB8YLLN1Q"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const remoteConfig = getRemoteConfig(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);